import { getMarketingAttributionData } from "../config/MarketingAttribution";
import { getProviderFlags } from "./marketingTracking";

const SIMPLIFI_BOOKING_INITIATED_SRC =
  "https://tag.simpli.fi/sifitag/db4a2d70-f7ab-41af-bb62-06b4cc2df149";
const SIMPLIFI_RESERVATION_COMPLETED_SRC =
  "https://tag.simpli.fi/sifitag/e4f91634-8c44-4421-9b96-2c5054450298";

const getDedupeKey = (eventType, keyBase) => {
  return `simplifi_conv:${eventType}:${keyBase}`;
};

const injectScript = (src, eventType, reservationSlug) => {
  if (!src) {
    return;
  }
  if (document.querySelector(`script[src="${src}"]`)) {
    return;
  }
  const script = document.createElement("script");
  script.src = src;
  script.async = true;
  script.referrerPolicy = "strict-origin-when-cross-origin";
  document.body.appendChild(script);
  if (process.env.REACT_APP_CUSTOM_NODE_ENV === "staging") {
    console.info("[Simpli.fi] Conversion tag injected", {
      eventType,
      reservationSlug,
      src,
    });
  }
};

export const fireSimpliFiConversion = ({
  eventType,
  reservationSlug,
  dedupeKeyOverride,
}) => {
  try {
    const providerFlags = getProviderFlags();
    if (providerFlags && providerFlags.SIMPLIFI_ENABLED === false) {
      return;
    }
    const marketingData = getMarketingAttributionData() || {};
    const sfiClickId =
      typeof marketingData.sfi_click_id === "string"
        ? marketingData.sfi_click_id.trim()
        : "";
    if (!sfiClickId) {
      if (process.env.REACT_APP_CUSTOM_NODE_ENV === "staging") {
        console.info("[Simpli.fi] Conversion tag skipped (no sfi_click_id)", {
          eventType,
          reservationSlug,
          dedupeKeyOverride,
        });
      }
      return;
    }

    if (!eventType) {
      if (process.env.REACT_APP_CUSTOM_NODE_ENV === "staging") {
        console.info("[Simpli.fi] Conversion tag skipped (missing data)", {
          eventType,
          reservationSlug,
          dedupeKeyOverride,
        });
      }
      return;
    }

    const keyBase = dedupeKeyOverride || reservationSlug;
    if (!keyBase) {
      if (process.env.REACT_APP_CUSTOM_NODE_ENV === "staging") {
        console.info("[Simpli.fi] Conversion tag skipped (missing data)", {
          eventType,
          reservationSlug,
          dedupeKeyOverride,
        });
      }
      return;
    }

    const dedupeKey = getDedupeKey(eventType, keyBase);
    if (localStorage.getItem(dedupeKey)) {
      if (process.env.REACT_APP_CUSTOM_NODE_ENV === "staging") {
        console.info("[Simpli.fi] Conversion tag deduped", {
          eventType,
          reservationSlug,
          dedupeKeyOverride,
          dedupeKey,
        });
      }
      return;
    }

    localStorage.setItem(dedupeKey, "1");
    if (eventType === "booking_initiated") {
      injectScript(SIMPLIFI_BOOKING_INITIATED_SRC, eventType, reservationSlug);
    } else if (eventType === "reservation_completed") {
      injectScript(
        SIMPLIFI_RESERVATION_COMPLETED_SRC,
        eventType,
        reservationSlug
      );
    }
  } catch (e) {
    // No-op: tracking should not block user flow
  }
};
